export enum DisplayFields {
  POPOUT = "popout",
  ALL = "all",
}
